export default __webpack_public_path__ + "static/media/Medium.142e8dc6.woff";